export * from './about-us/about-us.component';
export * from './privacy-policy/privacy-policy.component';
export * from './support/support.component';
export * from './home-support/home-support.component';
export * from './home-discover/home-discover.component';
export * from './home-getpaid/home-getpaid.component';



// WEBPACK FOOTER //
// ./src/app/cms/index.ts